import { all } from 'redux-saga/effects';
import * as ChangeRequestSagas from '@/app/areas/unacknowledged-po/details/components/change-requests/change-requests-sagas';
import * as HoldRequestSagas from '@/app/areas/unacknowledged-po/details/components/hold-requests/hold-requests-sagas';
import * as ConversationSagas from '@/app/common/conversation/sagas';
import * as CreateChangeRequestSagas from '@/app/areas/unacknowledged-po/details/components/create-change-request/change-request-sagas';
import * as DetailsPageSagas from '@/app/areas/unacknowledged-po/details/sagas';
import * as ListPageSagas from '@/app/areas/unacknowledged-po/list/sagas';
import * as POCreateChangeRequestSagas from '@/app/areas/unacknowledged-po/details/components/create-po-change-request/sagas';
import * as ReasonTypeSagas from '@/app/common/reference-data/reference-data-saga';
import * as UserSagas from '@/app/common/user/sagas';
import * as FeatureFlagSagas from '@/app/common/featureFlags/featureFlagsSaga';
import * as UserAccessPoliciesSagas from '@/app/common/userAccessPolicy/sagas';
import * as UserProfileSagas from '@/app/common/userProfile/sagas';

export const rootSaga = function* rootSaga() {
  yield all([
    ChangeRequestSagas.watchBuyerApproveChangeRequest(),
    ChangeRequestSagas.watchGetPoItemChangeRequestsSaga(),
    ChangeRequestSagas.watchSupplierApproveChangeRequest(),
    ConversationSagas.watchCancelConfirmSaga(),
    ConversationSagas.watchDeleteMessageRecipient(),
    ConversationSagas.watchGetConversationSaga(),
    ConversationSagas.watchGetNotesSaga(),
    ConversationSagas.watchPostConversationMessageSaga(),
    ConversationSagas.watchPostCreateConversationSaga(),
    ConversationSagas.watchPostNoteSaga(),
    CreateChangeRequestSagas.watchCreateChangeRequestSaga(),
    DetailsPageSagas.watchDeletePoConversationFollowupSaga(),
    DetailsPageSagas.watchGetConfirmedPoItemsSaga(),
    DetailsPageSagas.watchGetPoDetailsBucketTotalsSaga(),
    DetailsPageSagas.watchGetPoDetailsSaga(),
    DetailsPageSagas.watchGetPoItemsSaga(),
    DetailsPageSagas.watchGetRevisedPoItemsSaga(),
    DetailsPageSagas.watchPostApprovePoSaga(),
    DetailsPageSagas.watchPoUnreadSaga(),
    DetailsPageSagas.watchPutPoConversationFollowupSaga(),
    DetailsPageSagas.watchSearchPoItemsSaga(),
    HoldRequestSagas.watchGetPoItemHoldRequestsSaga(),
    ListPageSagas.watchPoListSaga(),
    POCreateChangeRequestSagas.watchPoCreateChangeRequestSaga(),
    ReasonTypeSagas.watchGetChangeRequestReasonTypesSaga(),
    UserSagas.watchGetUserRequests(),
    FeatureFlagSagas.watchFeatureFlags(),
    UserAccessPoliciesSagas.watchGetUserAccessPolicyRequests(),
    UserProfileSagas.watchGetUserProfile(),
  ]);
};
